import { riskColors } from "@/theme";

interface BadgeProps {
  risk: keyof typeof riskColors;
  children?: React.ReactNode;
}

const labels: Record<string, string> = {
  compliant: "Compliant",
  high_risk: "High Risk",
  hard_reject: "Hard Reject",
  unverified: "Unverified",
  AMBITIOUS: "Ambitious",
  TARGET: "Target",
  SAFETY: "Safety",
  HARD_REJECT: "Hard Reject",
};

const fallback = { bg: "bg-gray-50", text: "text-gray-600", border: "border-gray-300" };

export function Badge({ risk, children }: BadgeProps) {
  const colors = riskColors[risk] ?? fallback;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-semibold tracking-wide rounded-full border ${colors.bg} ${colors.text} ${colors.border}`}
    >
      {children ?? labels[risk]}
    </span>
  );
}
